/**
 * @param {number} ms - sleep for n ms
 */
export default (ms) => new Promise((resolve) => { setTimeout(resolve, ms) })
